/**
 * @description Constants module
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module config/Constants
 */

/**
 * @constant
 * @type {object}
 * @description Exports an object containing constants that are used throughout the application.
 */
const CONSTANTS = {
    // Time in ms to attempt reconnection to data service.
    DATA_SERVICE_RECONNECT_DELAY: 20000,
    // Time in ms to display a toast notification.
    TOAST_DISPLAY_TIME: 2000,
    // Notification messages.
    NOTIFICATIONS: {
        // Notification message details after data service has disconnected.
        DISCONNECTION_MESSAGE: {
            type: 'error',
            title: 'Service Disconnected',
            message:
                'The data service disconnected. Please wait to attempt an automatic reconnection, or click below to reconnect.'
        },
        // Notification message details after successful reconnection to data service.
        RECONNECTION_MESSAGE: {
            type: 'toast',
            title: 'Service Reconnected',
            message: 'The data service reconnected.'
        },
        // Notification message details after failed connection to data service.
        CONNECTION_ERROR_MESSAGE: {
            type: 'error',
            title: 'Service Connection Error',
            message: 'There was a problem connecting to the data service. Please try again later.'
        },
        // Notification message details after failure to get delay data.
        DELAY_DATA_ERROR_MESSAGE: {
            type: 'error',
            title: 'Data Error',
            message: 'There was a problem retrieving the delay data. Please try again later.'
        },
        // Notification message details after failure to get route data.
        ROUTE_DATA_ERROR_MESSAGE: {
            type: 'error',
            title: 'Data Error',
            message: 'There was a problem retrieving the route data. Please try again later.'
        },
        // Notification message details after failure to get heatmap data.
        HEATMAP_DATA_ERROR_MESSAGE: {
            type: 'error',
            title: 'Data Error',
            message: 'There was a problem retrieving the heatmap data. Please try again later.'
        }
    },
    // Default data update interval in minutes.
    UPDATE_INTERVAL_MINS: 15,
    ROUTE_SELECTION_STATE: {
        deselected: -1,
        partial: 0,
        complete: 1
    }
};

export default CONSTANTS;
